import { render, staticRenderFns } from "./Crowd.vue?vue&type=template&id=45c0fd56&"
import script from "./Crowd.vue?vue&type=script&lang=js&"
export * from "./Crowd.vue?vue&type=script&lang=js&"
import style0 from "./Crowd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports